import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import { Chip, Show } from '@side/pantry';
import { useRouter } from 'next/router';
import { useReferral } from '@/common/hooks/referrals/useReferral';
import { useRouteParam } from '@/common/hooks/useRouteParam';
import { BaseSideNavigation } from '@/components/BaseSideNavigation/BaseSideNavigation';
import { Link } from '@/components/SideBar/components/Link';
import { TXM_REFERRALS_PATH } from '@/constants';
import { useReferralSummaryText } from './ReferralSummary.helpers';
import { useMissingRequiredFields } from './SidebarContent.helpers';

export function SidebarContent() {
  const referralId = useRouteParam('referralId');
  const { basePath: txmBasePath } = useRouter();
  const basePath = `${txmBasePath}${TXM_REFERRALS_PATH}/${referralId}`;
  const { formPath, missingFields } = useMissingRequiredFields(referralId);
  const { summary } = useReferralSummaryText();
  const { interaction } = useReferral(referralId);

  return (
    <BaseSideNavigation
      Icon={
        <ArrowCircleUpIcon
          sx={{
            rotate: '90deg',
            color: 'grey.600',
          }}
          fontSize="small"
        />
      }
      title={summary}
      extraHeaderContent={
        <Show when={interaction?.isArchived}>
          <Chip
            label="This referral is archived"
            variant="outlined"
            sx={{
              borderRadius: 0.5,
              alignSelf: 'start',
            }}
          />
        </Show>
      }
    >
      <Link path={basePath} label="Referral Overview" />
      <Link
        path={`${basePath}/agreement`}
        label="Referral Agreement"
        interactionId={referralId}
        CoverSheetLinkBadgeProps={{
          count: missingFields.length,
          tooltip: 'Referral Agreement missing required fields',
          formPath,
          missingFieldsData: missingFields,
        }}
      />
      <Link
        path={`${basePath}/documents`}
        label="Documents"
        disabled={missingFields.length > 0}
      />
    </BaseSideNavigation>
  );
}
